// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__5IBev","filled":"Button_filled__3ivnK","outlined":"Button_outlined__2YYYJ"};